import React, { Component } from "react";
import {
  Collapse,
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
import "./NavMenu.css";

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  closeNavBar = () => this.setState({collapsed:true});

  render() {
    if (!this.props.isAuthenticated) {
      return <></>;
    }
    return (
      <header>
        <Navbar
          className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
          light
        >
          <Container>
            <NavbarBrand tag={Link} to="/">
              Lillin & Petrin Häät 12.9.2020
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse
              className="d-sm-inline-flex flex-sm-row-reverse"
              isOpen={!this.state.collapsed}
              navbar
            >
              <ul className="navbar-nav flex-grow">
                <NavItem>
                  <NavLink tag={Link} onClick={this.closeNavBar} className="text-dark" to="/tervetuloa">
                    Tervetuloa
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} onClick={this.closeNavBar} className="text-dark" to="/tarina">
                    Tarina
                  </NavLink>
                </NavItem>
                {/*
                <NavItem>
                  <NavLink tag={Link} onClick={this.closeNavBar} className="text-dark" to="/info">
                    Info
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} onClick={this.closeNavBar} className="text-dark" to="/ohjelma">
                    Ohjelma
                  </NavLink>
                </NavItem>
                */}
                {
                <NavItem>
                  <NavLink tag={Link} onClick={this.closeNavBar} className="text-dark" to="/kuvat">
                    Kuvat
                  </NavLink>
                </NavItem>
                }
                {this.props.isAdmin && (
                  <>
                    <NavItem>
                      <NavLink
                        tag={Link}
                        onClick={this.closeNavBar}
                        className="text-dark"
                        to="/registrants"
                      >
                        Rekisteröityneet
                      </NavLink>
                    </NavItem>
                  </>
                )}
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
